import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core'
import Search from '../../../uiKit/Search/Search'
import FilterBar from '../../../uiKit/FilterBar'
import FilterSelect from '../../../uiKit/FilterSelect'

const searchStyles = () => ({
  searchFix: {
    '& > div': {
      borderRadius: 'var(--careco-rounded-sm)',
    },
    '& input': {
      height: 48,
      border: '1px solid var(--careco-border)',
      borderRadius: 'var(--careco-rounded-sm)',
      padding: '0 44px 0 var(--careco-space-sm)',
      fontSize: 14,
      color: 'var(--careco-text-primary)',
      transition: 'border-color 120ms ease',
      '&::placeholder': { color: 'var(--careco-text-muted)' },
      '&:hover': { borderColor: 'var(--careco-primary)' },
      '&:focus': { borderColor: 'var(--careco-primary)' },
      '&:focus-visible': {
        outline: '2px solid var(--careco-primary)',
        outlineOffset: 2,
      },
    },
  },
})

const SearchField = withStyles(searchStyles)(({ classes, ...props }) => (
  <div className={classes.searchFix}>
    <Search {...props} />
  </div>
))

const BotsToolbar = props => {
  const {
    search,
    roleFilter,
    assistantFilter,
    roleOptions,
    total,
    shown,
    onSearchChange,
    onRoleChange,
    onAssistantChange,
    onClear,
    trailing,
  } = props

  return (
    <FilterBar
      total={total}
      shown={shown}
      itemNoun="organisation"
      onClear={onClear}
      trailing={trailing}
      search={
        <SearchField
          placeholder="Search organisations"
          value={search}
          onChange={event => onSearchChange(event.target.value)}
        />
      }
      filters={
        <>
          <FilterSelect
            label="Filter by your access"
            allLabel="All access levels"
            value={roleFilter}
            onChange={onRoleChange}
            options={roleOptions.map(option => ({
              value: option.value,
              label: option.label,
            }))}
          />
          {onAssistantChange && (
            <FilterSelect
              label="Filter by assistant status"
              allLabel="Any assistant status"
              value={assistantFilter}
              onChange={onAssistantChange}
              options={[
                { value: 'ready', label: 'Assistant active' },
                { value: 'not-ready', label: 'Assistant not set up' },
              ]}
            />
          )}
        </>
      }
    />
  )
}

BotsToolbar.propTypes = {
  search: PropTypes.string,
  roleFilter: PropTypes.string,
  assistantFilter: PropTypes.string,
  roleOptions: PropTypes.array,
  total: PropTypes.number,
  shown: PropTypes.number,
  onSearchChange: PropTypes.func,
  onRoleChange: PropTypes.func,
  onAssistantChange: PropTypes.func,
  onClear: PropTypes.func,
  trailing: PropTypes.node,
}

export default BotsToolbar
